const STORAGE_KEY = 'forfatterspill:admin:v1';

type Listener = (aktiv: boolean) => void;

const listeners = new Set<Listener>();
let initialized = false;

export function erAdminAktivert(): boolean {
  if (typeof window === 'undefined') return false;
  if (!initialized) {
    initialiserFraUrlOgStorage();
    initialized = true;
  }
  try {
    return localStorage.getItem(STORAGE_KEY) === '1';
  } catch {
    return false;
  }
}

export function settAdminAktivert(aktiv: boolean): void {
  if (typeof localStorage === 'undefined') return;
  try {
    if (aktiv) localStorage.setItem(STORAGE_KEY, '1');
    else localStorage.removeItem(STORAGE_KEY);
  } catch {
    /* noop */
  }
  for (const l of listeners) l(aktiv);
}

export function vekslAdmin(): boolean {
  const ny = !erAdminAktivert();
  settAdminAktivert(ny);
  return ny;
}

export function abonnerAdmin(fn: Listener): () => void {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

export function registrerAdminShortcut(): void {
  if (typeof window === 'undefined') return;
  if ((window as unknown as { __adminShortcutRegistrert?: boolean }).__adminShortcutRegistrert) {
    return;
  }
  (window as unknown as { __adminShortcutRegistrert?: boolean }).__adminShortcutRegistrert = true;
  window.addEventListener('keydown', (ev) => {
    if (ev.ctrlKey && ev.shiftKey && (ev.key === 'A' || ev.key === 'a')) {
      ev.preventDefault();
      vekslAdmin();
    }
  });
}

function initialiserFraUrlOgStorage(): void {
  if (typeof window === 'undefined') return;
  try {
    const params = new URLSearchParams(window.location.search);
    if (params.get('admin') === '1') {
      localStorage.setItem(STORAGE_KEY, '1');
    }
  } catch {
    /* noop */
  }
}
